module.exports = __webpack_public_path__ + "static/media/IMG_2682.37543bb2.JPG";